import { FullLoadingIndicator } from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import {
  Organization,
  useOrganization,
} from '@foxtrotplatform/platform-micro-site-core';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { DeveloperOrganizationContextProps } from '../../../common/providers/types';

export const OrganizationCheck: React.FunctionComponent =
  (): JSX.Element | null => {
    const navigate = useNavigate();
    const {
      isOrganizationsReady,
      requiresOrgOnboarding,
      userEmailDomainOrg,
      setCurrentOrg,
      organizations,
    } = useOrganization() as DeveloperOrganizationContextProps;

    useEffect(() => {
      if (!isOrganizationsReady) {
        return;
      }

      if (requiresOrgOnboarding && userEmailDomainOrg) {
        setCurrentOrg({
          id: userEmailDomainOrg.id,
          companyName: userEmailDomainOrg.companyName || '',
        } as Organization);
        navigate('/organization/exists');
      }

      if (requiresOrgOnboarding && !userEmailDomainOrg) {
        navigate('/organization/create');
      }
    }, [requiresOrgOnboarding, userEmailDomainOrg, organizations]);

    if (!isOrganizationsReady) {
      return <FullLoadingIndicator hidden={false} underHeader={true} />;
    }

    return null;
  };
